import { React, useState, useEffect } from 'react'
import useDeviceType from '../../utils/useDeviceType';
import { useParams } from "react-router-dom";
import * as Assets from '../../assets';
import Landing from '../landing/Landing';

const Main = ({ usernameL }) => {

    const { isMobile, isTablet } = useDeviceType();

    //const links = [Assets.apple, Assets.DribbbleIcon, Assets.GithubIcon, Assets.RedditIcon, Assets.PinterestIcon, Assets.MediumIcon, Assets.CustomIcon, Assets.GithubIcon, Assets.RedditIcon, Assets.PinterestIcon, Assets.MediumIcon]
    const links = {
        "apple": Assets.apple,
        "instagram": Assets.InstagramIcon,
        "snapchat": Assets.SnapchatIcon,
        "facebook": Assets.FacebookIcon,
        "x": Assets.xIcon,
        "youTube": Assets.YouTubeIcon,
        "tikTok": Assets.TikTokIcon,
        "reddit": Assets.RedditIcon,
        "triller": Assets.TrillerIcon,
        "linktree": Assets.LinkedInIcon,
        "rumble": Assets.RumbleIcon,
        "threads": Assets.ThreadsIcon,
        "dribbble": Assets.DribbbleIcon,
        "linkedIn": Assets.LinkedInIcon,
        "telegram": Assets.TelegramIcon,
        "github": Assets.GithubIcon,
        "spotify": Assets.SpotifyIcon,
        "pinterest": Assets.PinterestIcon,
        "medium": Assets.MediumIcon,
        "twitch": Assets.TwitchIcon,
        "whatsUp": Assets.WhatsAppIcon,
        "signal": Assets.SignalIcon,
        "custom": Assets.CustomIcon,
    }

    const socialLinks = {
        "instagram": "https://www.instagram.com/",
        "snapchat": "https://www.snapchat.com/add/",
        "facebook": "https://www.facebook.com/",
        "x": "www.x.com/",
        "youTube": "https://www.youtube.com/@",
        "tikTok": "https://www.tiktok.com/@",
        "reddit": "https://www.reddit.com/user/",
        "triller": "https://www.triller.com/",
        "linktree": "https://www.linktr.ee/",
        "rumble": "https://www.rumble.com/",
        "threads": "https://www.threads.net/",
        "dribbble": "https://dribbble.com/",
        "linkedIn": "https://www.linkedin.com/in/",
        "telegram": "https://t.me/",
        "github": "https://github.com/",
        "spotify": "https://open.spotify.com/user/",
        "pinterest": "https://www.pinterest.com/",
        "apple": "https://music.apple.com/profile/",
        "medium": "https://medium.com/@",
        "twitch": "https://www.twitch.tv/",
        "whatsUp": "https://wa.me/",
        "signal": "https://signal.me/",
    }

    const { username } = useParams();
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [profileImage, setProfileImage] = useState(Assets.profile_placeholder);
    const [backgroundImage, setBackgroundImage] = useState(Assets.bg_placeholder);

    useEffect(() => {
        const fetchProfile = async () => {
            let data;
            try {
                const res = await fetch(`https://tough-bedbug-crack.ngrok-free.app/${username}`, {
                    method: "GET",
                    headers: {
                        "ngrok-skip-browser-warning": "true",
                        "Content-Type": "application/json"
                    }
                });
                if (!res.ok) {
                    throw new Error(`Error fetching profile: ${res.statusText}`);
                }
                data = await res.json();
                setProfileData(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
                if ( data != null ) {
            try {
                // After fetching profile, get the image
                const imageUrl = `https://tough-bedbug-crack.ngrok-free.app/static/${data.user.userProfileImg}`;
                const imageRes = await fetch(imageUrl, {
                    headers: {
                        "ngrok-skip-browser-warning": "true", // Skip warning page
                    }
                });
                
                // if (!imageRes.ok) {
                //     throw new Error(`Error fetching image: ${imageRes.statusText}`);
                // }
               
                
                const imageBlob = await imageRes.blob();
                const imageObjectURL = URL.createObjectURL(imageBlob);
                setProfileImage(imageObjectURL); // Store the image in state
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
                
            try {
                // Fetch background image
                const backgroundImageUrl = `https://tough-bedbug-crack.ngrok-free.app/static/${data.user.userBgImg}`;
                const backgroundImageRes = await fetch(backgroundImageUrl, {
                    headers: {
                        "ngrok-skip-browser-warning": "true",
                    }
                });

                // if (!backgroundImageRes.ok) {
                //     throw new Error(`Error fetching background image: ${backgroundImageRes.statusText}`);
                // }
                
                const backgroundImageBlob = await backgroundImageRes.blob();
                const backgroundImageObjectURL = URL.createObjectURL(backgroundImageBlob);
                setBackgroundImage(backgroundImageObjectURL);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }
        };

        if (username) {
            fetchProfile();
        }
    }, [username]);

    if (loading) return <p>Loading profile...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <section
            style={{ height: '100vh', position: 'relative', overflow: 'hidden' }}
        >
            <div
                style={{ height: '100%', width: '100%', maxWidth: '600px', display: 'flex', flexDirection: 'column', overflowY: 'auto', backgroundImage: `url(${backgroundImage})`, backgroundPosition: 'center', backgroundSize: 'cover', borderTopLeftRadius: isMobile ? '0px' : '20px', borderTopRightRadius: isMobile ? '0px' : '20px', marginTop: isMobile ? '0px' : '40px', }}
            >
                <div
                    style={{ minHeight: '100%', height: 'auto', width: '100%', background: 'linear-gradient(to bottom, transparent 0%, transparent 5%, black 30%)', marginTop: '10rem', paddingBottom: '50px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >

                    {/* profile intro */}
                    <div
                        style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center'
                        }}
                    >
                        <div style={{ position: 'relative', zIndex: 1, marginTop: '50px' }}>
                            {/* Profile Image Border */}
                            <div
                                style={{
                                    width: '100px',
                                    height: '100px',
                                    borderRadius: '50%',
                                    overflow: 'hidden',
                                    border: '5px solid rgba(169, 169, 169, 0.4)',
                                }}
                            >
                                {/* Profile Image */}
                                <img
                                    src={profileImage}
                                    alt="Profile Placeholder"
                                    loading="lazy"
                                    onError={(e) => { e.target.src = Assets.profile_placeholder; }}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}

                                />
                            </div>
                        </div>

                        <div style={{ paddingTop: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {/* Username */}
                            <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: 'white' }}>
                                {profileData.user.username}
                            </div>

                            {/* Short Description */}
                            <div style={{ color: 'gray', fontSize: '0.875rem' }}>
                                {profileData.user.userShortDesc}
                            </div>

                            {/* Long Description */}
                            <div
                                style={{
                                    color: 'white',
                                    padding: '10px',
                                    maxWidth: '100%',
                                    textAlign: 'center',
                                    fontSize: '0.75rem',
                                    whiteSpace: 'normal',
                                }}
                            >
                                {profileData.user.userLongDesc}
                            </div>
                        </div>
                    </div>

                    {/* social media links */}
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            gap: '10px',
                            paddingTop: '20px',
                            //overflowX: 'auto',
                            //whiteSpace: 'nowrap'
                        }}
                    >
                        {profileData.links.map((link) =>
                            link.linkType !== "custom" ? (
                                <a
                                    href={socialLinks[link.linkType] + link.linkUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'inline-block' }}
                                >
                                    <div
                                        style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '50%',
                                            overflow: 'hidden',
                                            flexShrink: 0
                                        }}
                                    >
                                        {/* Link Icon */}
                                        <img
                                            src={links[link.linkType]}
                                            alt="Profile Placeholder"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </div>
                                </a>
                            ) : (
                                null
                            ))}
                    </div>

                    {/* custom links */}
                    <div
                        style={{
                            width: '90%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            gap: '15px',
                            paddingTop: '50px'
                        }}
                    >
                        {profileData.links.map((link) =>
                            link.linkType === "custom" ? (
                                <a
                                    href={link.linkUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'inline-block' }}
                                    textDecoration='none'
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: '10px',
                                            paddingTop: '15px',
                                            paddingBottom: '15px',
                                            background: '#1E1E1E',
                                            borderRadius: '10px',

                                        }}
                                    >
                                        <div
                                            style={{
                                                //width: '30px',
                                                height: '30px',
                                                borderRadius: '5px',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {/* Link Icon */}
                                            {/* <img
                                                src={Assets.CustomIcon}
                                                alt="Profile Placeholder"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            /> */}
                                            <img
                                                src={`https://icons.duckduckgo.com/ip3/${new URL(link.linkUrl).hostname}.ico`}
                                                alt="Favicon"
                                                onError={(e) => {
                                                    e.target.onerror = null; // prevent infinite loop
                                                    e.target.src = Assets.CustomIcon; // set your placeholder image path
                                                }}
                                                style={{
                                                    //width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </div>
                                        <span
                                            style={{
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                color: 'white',
                                                alignSelf: 'center',
                                                textDecoration: 'none'
                                            }}
                                            textDecoration='none'
                                        >
                                            {link.linkUrl}
                                        </span>
                                    </div>
                                </a>
                            ) : (
                                null
                            ))}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingTop: '50px',
                            gap: '15px'
                        }}
                    >
                        {/* Logo Icon */}
                        <div
                            style={{
                                width: '50px',
                                height: '50px',
                                overflow: 'hidden',
                            }}
                        >
                            <img
                                src={Assets.Logo}
                                alt="Logo"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </div>

                        {/* Call to Action */}
                        <span
                            style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: 'white',
                                alignSelf: 'center',
                                border: '0.2px solid rgba(110, 110, 110, 0.4)',
                                padding: '15px',
                                borderRadius: '30px',
                            }}
                        >
                            Get your profile
                        </span>

                        {/* Terms */}
                        <a
                            style={{
                                fontSize: '12px',
                                fontWeight: '200',
                                color: 'white',
                                alignSelf: 'center',
                            }}
                        >
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Main